module.exports = __webpack_public_path__ + "img/s4.aacff42.png";